import React from "react";
import CMarkdown from "../CMarkdown";
import style from './index.module.scss';

const CRecommend = (props) => {
  const { content, askQuestion, taskType, recommendOrder } = props
  return (
    <div className={style.recommend} >
      <span className={style.order}>{recommendOrder + 1}、</span>
      <CMarkdown content={`<QA>${content}</QA>`} onClick={() => askQuestion(content, { taskType })} />
    </div>
  )
}

export default CRecommend
